import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Auth from "../plugins/auth";
import Interests from "@/views/interests/index.vue"
import Customers from "@/views/customers/index.vue";
import Login from "../views/Login.vue";
import GeneratePassword from "../views/GeneratePassword.vue";
import Investments from "../views/investments/index.vue";
import Products from "@/views/products/index.vue";
import Notifications from "../views/notifications/index.vue";

import NotificationByEmail from "../views/notification-email/index.vue";
import NotificationEmailInformation from "../views/notification-email/view.vue"
import NotificationEmailCreate from "../views/notification-email/new.vue";
import Dashboard from "../views/home/dashboard.vue"

import Accounts from "../views/accounts/index.vue";
import Documents from "../views/accounts/documents.vue";
import Companies from "../views/companies/index.vue";
import CompanyForm from "../views/companies/form.vue";
import ImportCompany from "../views/companies/import.vue";
import ProductForm from "@/views/products/new.vue";
import ProductDetail from "@/views/products/edit.vue";
import CustomerForm from "@/views/customers/form.vue";
import Schedules from "@/views/schedules/Schedules.vue";
import AuditLogs from "@/views/audit-logs/index.vue";
import Subdocument from "@/views/subdocs/index.vue"
import CIPImport from "@/views/subdocs/import.vue"
import TestComponents from "@/views/test/index.vue"
import NewsIndex from "@/views/news/index.vue"
import NewsForm from "@/views/news/form.vue"
import LesteManagers from "@/views/leste-manager/index.vue"
import LesteManagerDetail from "@/views/leste-manager/detail.vue"

const auth = new Auth();

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Home",
    component: Customers,
    beforeEnter: auth.requireAuth,   
    redirect: (to) => {
      return { path: '/administration/users', query: { q: to.params.searchText } }
    },
  },    
  {
    path: "/login",
    name: "Login",
    component: Login,
  },

  {
    path: "/administration/auditlogs",
    name: "AuditLogs",
    component: AuditLogs,
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/administration/companies",
    name: "Companies",
    component: Companies,
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/administration/companies/new",
    name: "CompanyFormNew",
    component: CompanyForm,
    props: (route) => ({
      companyId: String(route.params.companyId),
      formType: route.params.formType,
    }),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/administration/companies/:formType/:companyId",
    name: "CompanyFormView",
    component: CompanyForm,
    props: (route) => ({
      companyId: String(route.params.companyId),
      formType: route.params.formType,
    }),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/administration/companies/import",
    name: "CompanyImport",
    component: ImportCompany, 
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/administration/interests",
    name: "Interests",
    component: Interests,
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/administration/cip-import",
    name: "CIP-Import",
    component: CIPImport,
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/administration/users",
    name: "Users",
    component: Customers,
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/administration/leste-managers",
    name: "LesteManagers",
    component: LesteManagers,
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/administration/leste-managers/detail/:customerId",
    name: "LesteManagerDetails",
    props: (route) => ({
      customerId: String(route.params.customerId)
    }),
    component: LesteManagerDetail,
    beforeEnter: auth.requireAuth,
  },  
  {
    path: "/administration/user/:formType/:customerId",
    name: "UserForm",
    props: (route) => ({
      customerId: String(route.params.customerId),
      formType: route.params.formType,
    }),
    component: CustomerForm,
    beforeEnter: auth.requireAuth,
  },  
  {
    path: "/communication/notifications",
    name: "Notifications",
    component: Notifications,
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/communication/e-mail",
    name: "E-mail",
    component: NotificationByEmail,
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/communication/e-mail/view/:notificationId",
    name: "NotificationEmailView",
    props: (route) => ({
      notificationId: String(route.params.notificationId)
    }),
    component: NotificationEmailInformation,
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/communication/e-mail/create",
    name: "NotificationEmailCreate",
    component: NotificationEmailCreate,
    beforeEnter: auth.requireAuth
  },
  {
    path: "/communication/schedules",
    name: "Schedules",
    component: Schedules,
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/communication/news",
    name: "News",
    component: NewsIndex,
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/communication/news/:formType/:newId",
    name: "NewsForm",
    component: NewsForm,
    props: (route) => ({
      newId: String(route.params.newId),
      formType: route.params.formType,
    }),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/communication/news/:formType",
    name: "NewsAddForm",
    component: NewsForm,
    props: (route) => ({
      formType: route.params.formType,
    }),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/products",
    name: "Products",
    component: Products,
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/product/new",
    name: "ProductAddForm",
    component: ProductForm,
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/product/edit/:productId",
    name: "ProductDetail",
    props: (route) => ({
      productId: String(route.params.productId),
      tab: route.params.tab,
    }),
    component: ProductDetail,
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/product/save/:id",
    name: "ProductViewForm",
    component: ProductForm,
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/wallet/accounts",
    name: "Accounts",
    component: Accounts,
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/wallet/documents",
    name: "Documents",
    component: Documents,
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/wallet/investments",
    name: "Investments",
    component: Investments,
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/wallet/subdocs",
    name: "Subdocs",
    component: Subdocument,
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/password/new/:id",
    name: "GeneratePassword",
    component: GeneratePassword,
  },
  {
    path: "/test",
    name: "Test",
    component: TestComponents,
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/home",
    name: "Dashboard",
    component: Dashboard,
    beforeEnter: auth.requireAuth,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
